export default __webpack_public_path__ + "static/media/Classwin-logo-small.be202f17.svg";